export default "__VITE_ASSET__saTICS5I__"